/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_CodeInputs */

const vi_product_classification_code = /** @type {(inputs: Product_Classification_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã`)
};

/**

* @param {Product_Classification_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_code = /** @type {((inputs?: Product_Classification_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_code(inputs)
});